<template>
  <div class="vp-time-picker">
    <div class="vp-time-picker__label-row">
      <span v-if="showLabel" ref="label" class="vp-time-picker__label">
        <slot name="label">Duration</slot>
      </span>
      <slot name="affix" />
    </div>
    <div class="vp-time-picker__input">
      <vp-input class="vp-time-picker__input-hours" v-model="hours" v-bind="getInputProps('hours')" name="time-hours" @input="($evt) => update($evt, 'hours')">
        <template #suffix>
          <label class="vp-time-picker__input-suffix" for="time-hours" title="Hours">H</label>
        </template>
      </vp-input>
      <vp-input class="vp-time-picker__input-minutes" v-model="minutes" v-bind="getInputProps('minutes')" name="time-minutes" @input="($evt) => update($evt, 'minutes')">
        <template #suffix>
          <label class="vp-time-picker__input-suffix" for="time-minutes" title="Minutes">MIN</label>
        </template>
      </vp-input>
    </div>
  </div>
</template>

<script>
import VpInput from '../vp-input/VpInput.vue';

export default {
  name: 'VpTimerPicker',
  components: { VpInput },
  emits: ['input'],
  data: () => ({
    hours: null,
    minutes: null,
  }),
  props: {
    value: {
      type: Object,
      default: null,
      validator: (time) => time ? Object.keys(time).includes('hours', 'minutes') : true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    hourMax: {
      type: [String, Number],
      default: null,
    },
    minuteMax: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: String,
      default: '40px',
    },
    width: {
      type: String,
      default: '107px',
    },
    hourDefault: {
      type: [String, Number],
      default: null,
    },
    minuteDefault: {
      type: [String, Number],
      default: null,
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(time) {
        this.hours = isNaN(time.hours) ? this.hourDefault : Number(time.hours);
        this.minutes = isNaN(time.minutes) ? this.minuteDefault : Number(time.minutes);
      },
    },
  },
  methods: {
    getInputProps(type) {
      const options = {
        min: '0',
        type: 'number',
        placeholder: '00',
        width: this.width,
        height: this.height,
        disabled: this.disabled,
        styles: {
          padding: '0 0 0 1rem',
          disabledBackgroundColor: '#f2f2f2',
        },
      };
      if (type === 'hours' && this.hourMax !== null) options.max = this.hourMax;
      if (type === 'minutes' && this.minuteMax !== null) options.max = this.minuteMax;
      return options;
    },
    update(value, type) {
      const time = {
        hours: this.hours,
        minutes: this.minutes,
      };
      if (type) time[type] = value;
      if (!isNaN(this.hourMax) && this.hourMax !== null && Number(time.hours) > Number(this.hourMax)) time.hours = this.hourMax;
      if (!isNaN(this.minuteMax) && this.minuteMax !== null && Number(time.minutes) > Number(this.minuteMax)) time.minutes = this.minuteMax;
      return this.$emit('input', time);
    },
  },
};
</script>

<style lang="scss" scoped>
$offwhite: #FBFBFB;
$charcoal: #4F4F4F;

.vp-time-picker {
  display: flex;
  color: $charcoal;
  text-align: left;
  flex-direction: column;
  &__label {
    flex: 100%;
    gap: 0.25rem;
    height: 25px;
    font-size: 14px;
    display: flex;
    margin: 0 0 0 4px;
    &-row {
      display: flex;
    }
  }
  &__input {
    display: flex;
    column-gap: 1rem;
  }
  &::v-deep .vcl-input__element{
    width: 57px;
    color: $charcoal;
    border-radius: 6px 0 0 6px;
  }
  &::v-deep .vcl-input__input--suffix {
    width: 50px;
    height: 100%;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0 6px 6px 0;
    &:not(.is-disabled) {
      background: $offwhite;
    }
    label {
      color: $charcoal;
      margin: 0;
    }
  }
}
</style>
